<template>
  <section id="ContainerID" class="container-xl px-0" v-if="validUser==1">
    <div class>
      <div class="container position-relative">
        <span class="d-link">
          <img src="@/assets/img/DAMAC_Logo.png" class="log-img" alt />
        </span>
      </div>
      <section class="section-thank-index">
        <div class="container">
          <div class="row">
            <div class="col-10 col-sm-10 col-md-6 text-center mx-auto">
              <img src="@/assets/img/social-icons.png" class="img-fluid" />
            </div>
            <div class="col-12 col-sm-12 col-md-6 mt-5 mt-md-0 align-self-center">
              <h1 class="text-white">
                <div class="text-center text-md-left">
                  <p class="mb-0 italic-add-text mb-1" style="color: #CECECE;">Whet your appetite</p>
                  <p class="mb-0 normal-add-text text-white">FOR DISCOUNTS UP TO</p>
                  <p class="mb-0 discount-text">
                    <span>25</span>%
                    <span class="small-word">OFF</span>
                  </p>
                </div>
              </h1>
            </div>
          </div>
        </div>
      </section>
      <div class="container position-relative py-5">
        <img src="@/assets/img/new-logo2.png" class="img-fluid d-link-new" alt />
      </div>
    </div>

    <div class="main-container cus_py_10">
      <div class="container">
        <div class="col-12 col-md-11 mx-auto">
          <div>
            <p
              class="title mb-0 text-center"
            >SIGN ON AND SAVE ON DINING EXPERIENCES AT PARAMOUNT HOTEL</p>
            <p
              class="normal-text mb-5 text-center"
            >Help yourself to 5% off with each social media channel you sign on! And that's not all, you can win a one-night stay with our raffle draw!</p>
          </div>
          <!-- NEW CODE TO BE INTERGRATED  -->
          <div class="d-none">
            <div class="row pb-4">
              <div class="col-3 col-md-2 col-lg-1 pr-0">
                <div class="h-20 d-none d-md-block"></div>
                <div class="btn rounded-0 facebook-btn overflow-hidden" title="LinkedIn">
                  <img
                    src="@/assets/img/svg/facebook-f-brands.svg"
                    height="20"
                    width="20"
                    alt="linkedIn"
                  />
                </div>
              </div>

              <div class="col-9 col-md-10 col-lg-11 pl-0">
                <div>
                  <span class="light-text d-none d-md-block pl-2 text-truncate">
                    Facebook eg:
                    https://www.facebook.com/in/testuser/
                  </span>
                  <div class="d-flex align-items-center justify-content-center position-relative">
                    <div class="full-input-box">
                      <input
                        v-on:focus="HideTheMessage()"
                        v-on:blur="handleFacebook()"
                        v-model="fbuserurl"
                        type="text"
                        class="sm-input-box"
                      />
                    </div>
                    <div class="ml-1 all-status">
                      <!-- ON SUCCESS -->
                      <div class="success-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <polyline
                            class="path check"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            points="100.2,40.2 51.5,88.8 29.8,67.5 "
                          />
                        </svg>
                      </div>

                      <!-- ON UNSUCCESS -->
                      <div class="unsuccess-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="34.4"
                            y1="37.9"
                            x2="95.8"
                            y2="92.3"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="95.8"
                            y1="38"
                            x2="34.4"
                            y2="92.2"
                          />
                        </svg>
                      </div>

                      <!-- ON LOADING -->
                      <div class="spinner-border loader" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                  <!-- <p class="text-success text-center mt-1 small">{{ showMessages.linkedinMessage }}</p> -->
                </div>
              </div>

              <span class="light-text d-md-none text-truncate pl-3">
                Linkedin eg:
                https://www.facebook.com/in/testuser/
              </span>
            </div>

            <div class="row pb-4">
              <div class="col-3 col-md-2 col-lg-1 pr-0">
                <div class="h-20 d-none d-md-block"></div>
                <div class="btn rounded-0 insta-btn overflow-hidden" title="LinkedIn">
                  <img
                    src="@/assets/img/svg/instagram-brands.svg"
                    height="30"
                    width="30"
                    alt="linkedIn"
                  />
                </div>
              </div>

              <div class="col-9 col-md-10 col-lg-11 pl-0">
                <div>
                  <span class="light-text d-none d-md-block pl-2 text-truncate">
                    Instagram eg:
                    https://www.instagram.com/in/testuser/
                  </span>
                  <div class="d-flex align-items-center justify-content-center position-relative">
                    <div class="full-input-box">
                      <input
                        v-on:focus="HideTheMessage()"
                        v-on:blur="handleInstagram()"
                        v-model="instuserurl"
                        :disabled="instagramtextstatus"
                        type="text"
                        class="sm-input-box"
                      />
                    </div>
                    <div class="ml-1 all-status">
                      <!-- ON SUCCESS -->
                      <div class="success-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <polyline
                            class="path check"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            points="100.2,40.2 51.5,88.8 29.8,67.5 "
                          />
                        </svg>
                      </div>

                      <!-- ON UNSUCCESS -->
                      <div class="unsuccess-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="34.4"
                            y1="37.9"
                            x2="95.8"
                            y2="92.3"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="95.8"
                            y1="38"
                            x2="34.4"
                            y2="92.2"
                          />
                        </svg>
                      </div>

                      <!-- ON LOADING -->
                      <div class="spinner-border loader" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <span class="light-text d-md-none text-truncate pl-3">
                Instagram eg:
                https://www.facebook.com/in/testuser/
              </span>
            </div>

            <div class="row pb-4">
              <div class="col-3 col-md-2 col-lg-1 pr-0">
                <div class="h-20 d-none d-md-block"></div>
                <div class="btn rounded-0 twitter-btn overflow-hidden" title="LinkedIn">
                  <img
                    src="@/assets/img/svg/twitter-brands.svg"
                    height="30"
                    width="30"
                    alt="linkedIn"
                  />
                </div>
              </div>

              <div class="col-9 col-md-10 col-lg-11 pl-0">
                <div>
                  <span class="light-text d-none d-md-block pl-2 text-truncate">
                    Twitter eg:
                    https://www.twitter.com/in/testuser/
                  </span>
                  <div class="d-flex align-items-center justify-content-center position-relative">
                    <div class="full-input-box">
                      <input
                        v-on:focus="HideTheMessage()"
                        v-on:blur="handleTwitter()"
                        v-model="twitteruserurl"
                        :disabled="twittertextstatus"
                        type="text"
                        class="sm-input-box"
                      />
                    </div>
                    <div class="ml-1 all-status">
                      <!-- ON SUCCESS -->
                      <div class="success-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <polyline
                            class="path check"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            points="100.2,40.2 51.5,88.8 29.8,67.5 "
                          />
                        </svg>
                      </div>

                      <!-- ON UNSUCCESS -->
                      <div class="unsuccess-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="34.4"
                            y1="37.9"
                            x2="95.8"
                            y2="92.3"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="95.8"
                            y1="38"
                            x2="34.4"
                            y2="92.2"
                          />
                        </svg>
                      </div>

                      <!-- ON LOADING -->
                      <div class="spinner-border loader" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                  <!-- <p class="text-success text-center mt-1 small">{{ showMessages.linkedinMessage }}</p> -->
                </div>
              </div>

              <span class="light-text d-md-none text-truncate pl-3">
                Twitter eg:
                https://www.twitter.com/in/testuser/
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="container" style="max-width: 900px;">
        <!-- NEW ROW DATA -->
        <div class="row">
          <div class="col-lg-6">
            <!-- SOCIAL MEDIA (Facebook) START -->
            <span v-if="isfacebook != 5" class="light-text d-none d-md-block text-truncate">
              Facebook eg:
              https://www.facebook.com/testuser
            </span>
            <div v-if="isfacebook != 5" class="row pb-4">
              <div class="col-3 col-md-2 pr-0">
                <div class="d-none d-md-block"></div>
                <div
                  title="Facebook"
                  v-if="this.flag.isBtnFacebook !== 2"
                  class="btn facebook-btn rounded-0 ex align-items-center justify-content-center"
                >
                  <!-- <fb-signin-button
                      :params="fbSignInParams"
                      @success="onSignInSuccess"
                      @error="onSignInError"
                  >-->
                  <div>
                    <img
                      src="@/assets/img/svg/facebook-f-brands.svg"
                      alt="Facebook"
                      height="35"
                      width="30"
                    />
                  </div>
                  <!-- <div class="ml-xl-4 ml-md-3 ml-4 d-none">Sign in with Facebook</div> -->
                  <!-- </fb-signin-button> -->
                </div>
                <div
                  v-else
                  class="btn facebook-btn d-flex align-items-center justify-content-center overflow-hidden"
                >
                  <div>
                    <img
                      v-bind:src="fb_profile_url"
                      alt="Facebook"
                      height="35"
                      width="30"
                      class="profile-img"
                    />
                  </div>
                  <div class="ml-xl-4 ml-md-3 ml-4">{{ fb_user_name }}</div>
                </div>
              </div>

              <!-- <div class="col-12 col-md-1 d-none">
              <div class="h-20 mb-2 d-none d-md-block"></div>
              <p class="or-text text-center py-2 mb-0">OR</p>
              </div>-->

              <div class="col-9 col-md-10 pl-0">
                <div>
                  <div
                    class="d-flex align-items-center justify-content-center position-relative"
                    v-bind:class="[this.isfacebook ==1 ? 'loading' : '', this.isfacebook == 2 ? 'success' : '', this.isfacebook == 3 ? 'error' : '', this.isfacebook ==0 ? '' : '']"
                  >
                    <div class="input-box w-100">
                      <input
                        type="text"
                        class="sm-input-box"
                        v-on:focus="HideTheMessage()"
                        v-on:blur="handleFacebook()"
                        v-model="fbuserurl"
                      />
                    </div>
                    <div class="ml-1 all-status">
                      <!-- ON SUCCESS -->
                      <div class="success-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <polyline
                            class="path check"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            points="100.2,40.2 51.5,88.8 29.8,67.5 "
                          />
                        </svg>
                      </div>

                      <!-- ON UNSUCCESS -->
                      <div class="unsuccess-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="34.4"
                            y1="37.9"
                            x2="95.8"
                            y2="92.3"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="95.8"
                            y1="38"
                            x2="34.4"
                            y2="92.2"
                          />
                        </svg>
                      </div>

                      <!-- ON LOADING -->
                      <div class="spinner-border loader" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span v-if="isfacebook != 5" class="light-text d-md-none text-truncate pl-3">
                Facebook eg:
                https://www.facebook.com/testuser
              </span>
            </div>

            <!-- AFTER VERIFIED BUT NOT SUBMITED START -->
            <div class="col-12 d-none">
              <!-- v-if="isfacebook !== 5 && FacebookObject.facebook_is_submitted === 2" -->
              <div class="row pb-4">
                <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                  <div class="btn facebook-btn overflow-hidden" title="Facebook">
                    <img
                      src="@/assets/img/svg/facebook-f-brands.svg"
                      alt="Facebook"
                      height="33"
                      width="30"
                    />
                  </div>
                </div>
                <div class="col-9 col-md-10 px-2 social_link_verified verified_fb">
                  <div class>{{ showMessages.facebookMessage }}</div>
                </div>
              </div>
            </div>

            <!-- AFTER VERIFIED START -->
            <span v-if="isfacebook == 5" class="light-text d-none d-md-block text-truncate">
              Facebook eg:
              https://www.facebook.com/testuser
            </span>
            <div v-if="isfacebook==5" class="row pb-4 center-new">
              <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                <div class="btn facebook-btn overflow-hidden" title="Facebook">
                  <img
                    src="@/assets/img/svg/facebook-f-brands.svg"
                    alt="Facebook"
                    height="33"
                    width="30"
                  />
                </div>
              </div>
              <div class="col-9 col-md-10 px-2 social_link_verified verified_fb">
                <div class="w-100 d-flex align-items-center justify-content-between">
                  <div class>Details has been already captured</div>
                  <div class="p_value p_value_facebook">
                    <span>{{ showPonits.facebookPoint }}</span>%
                  </div>
                </div>
              </div>
              <span v-if="isfacebook==5" class="light-text d-md-none text-truncate">
                Facebook eg:
                https://www.facebook.com/testuser
              </span>
            </div>

            <!-- AFTER VERIFIED END -->

            <!-- SOCIAL MEDIA (Facebook) END -->
          </div>

          <div class="col-lg-6">
            <!-- SOCIAL MEDIA (Instagram) START -->
            <span
              v-if="isinstagram != 5"
              class="light-text d-none d-md-block text-truncate"
            >Instagram eg: testuser</span>
            <div v-if="isinstagram != 5" class="row pb-4">
              <div class="col-3 col-md-2 pr-0">
                <div class="d-none d-md-block"></div>
                <!-- v-if="this.flag.isBtnInstagram !== 2"
                @click="instagramLogin()"-->
                <div title="Instagram" class="btn insta-btn d-flex rounded-0 overflow-hidden">
                  <div>
                    <img
                      src="@/assets/img/svg/instagram-brands.svg"
                      height="30"
                      width="30"
                      alt="instagram"
                    />
                  </div>
                </div>
                <!-- <div v-else class="btn insta-btn rounded-0 d-flex overflow-hidden">
                    <div>
                      <img
                        v-bind:src="inst_profile_url"
                        alt="instagram"
                        height="35"
                        width="30"
                        class="profile-img"
                      />
                    </div>
                    <div class="ml-xl-4 ml-md-3 ml-4">{{ inst_user_name }}</div>
                </div>-->
              </div>

              <!-- <div class="col-12 col-md-1">
              <p class="or-text text-center py-2 mb-0">OR</p>
              </div>-->

              <div class="col-9 col-md-10 pl-0">
                <div>
                  <div
                    class="d-flex align-items-center justify-content-center position-relative"
                    v-bind:class="[this.isinstagram ==1 ? 'loading' : '', this.isinstagram == 2 ? 'success' : '', this.isinstagram ==3 ? 'error' : '', this.isinstagram ==0 ? '' : '']"
                  >
                    <div class="input-box w-100">
                      <input
                        type="text"
                        class="sm-input-box"
                        v-on:focus="HideTheMessage()"
                        v-on:blur="handleInstagram()"
                        v-model="instuserurl"
                        :disabled="instagramtextstatus"
                      />
                    </div>
                    <div class="ml-1 all-status">
                      <!-- ON SUCCESS -->
                      <div class="success-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <polyline
                            class="path check"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            points="100.2,40.2 51.5,88.8 29.8,67.5 "
                          />
                        </svg>
                      </div>

                      <!-- ON UNSUCCESS -->
                      <div class="unsuccess-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="34.4"
                            y1="37.9"
                            x2="95.8"
                            y2="92.3"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="95.8"
                            y1="38"
                            x2="34.4"
                            y2="92.2"
                          />
                        </svg>
                      </div>

                      <!-- ON LOADING -->
                      <div class="spinner-border loader" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                  <!-- <span
                  class="text-success text-center mt-1 error-msg"
                  >{{ showMessages.instagramMessage }}</span>-->
                </div>
              </div>
              <span
                v-if="isinstagram != 5"
                class="light-text d-md-none text-truncate pl-3"
              >Instagram eg: testuser</span>
            </div>

            <!-- AFTER VERIFIED BUT NOT SUBMITED START -->
            <div class="d-none col-12">
              <div
                v-if="isinstagram !== 5 && InstaObject.instagram_is_submitted === 2"
                class="row pb-4"
              >
                <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                  <div class="btn insta-btn overflow-hidden" title="Instagram">
                    <img
                      src="@/assets/img/svg/instagram-brands.svg"
                      height="32"
                      width="32"
                      alt="instagram"
                    />
                  </div>
                </div>
                <div class="col-9 col-md-10 px-2 social_link_verified verified_insta">
                  <div class>{{ showMessages.instagramMessage }}</div>
                </div>
              </div>
            </div>

            <!-- AFTER VERIFIED START -->
            <span
              v-if="isinstagram == 5"
              class="light-text d-none d-md-block text-truncate"
            >Instagram eg: testuser</span>
            <div v-if="isinstagram == 5" class="row pb-4 center-new">
              <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                <div class="btn insta-btn overflow-hidden" title="Instagram">
                  <img
                    src="@/assets/img/svg/instagram-brands.svg"
                    height="32"
                    width="32"
                    alt="instagram"
                  />
                </div>
              </div>
              <div class="col-9 col-md-10 px-2 social_link_verified verified_insta">
                <div class="w-100 d-flex align-items-center justify-content-between">
                  <div class>Details has been already captured</div>
                  <div class="p_value p_value_insta">
                    <span>{{ showPonits.instagramPoint }}</span>%
                  </div>
                </div>
              </div>
              <span
                v-if="isinstagram == 5"
                class="light-text d-md-none text-truncate"
              >Instagram eg: testuser</span>
            </div>

            <!-- AFTER VERIFIED END -->
            <!-- SOCIAL MEDIA (Instagram) END -->
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <!-- SOCIAL MEDIA (Twitter) START -->
            <span
              v-if="istwitter != 5"
              class="light-text d-none d-md-block text-truncate"
            >Twitter eg: testuser</span>
            <div v-if="istwitter != 5" class="row pb-4">
              <div class="col-3 col-md-2 pr-0">
                <div class="d-none d-md-block"></div>
                <!-- v-if="this.flag.isBtnTwitter !== 2"
                @click="twitteronSignIn()"-->
                <div
                  title="Twitter"
                  class="btn twitter-btn rounded-0 ex align-items-center justify-content-center overflow-hidden"
                >
                  <div>
                    <img
                      src="@/assets/img/svg/twitter-brands.svg"
                      height="35"
                      width="35"
                      alt="twitter"
                    />
                  </div>
                  <!-- <div class="ml-xl-4 ml-md-3 ml-4">Sign in with Twitter</div> -->
                </div>
                <!-- <div
                    v-else
                    class="btn twitter-btn d-flex align-items-center justify-content-center overflow-hidden"
                  >
                    <div>
                      <img
                        v-bind:src="twitter_profile_url"
                        alt="instagram"
                        height="35"
                        width="30"
                        class="profile-img"
                      />
                    </div>
                    <div class="ml-xl-4 ml-md-3 ml-4">{{ twitter_user_name }}</div>
                </div>-->
              </div>

              <!-- <div class="col-12 col-md-1">
              <div class="h-20 mb-2 d-none d-md-block"></div>
              <p class="or-text text-center py-2 mb-0">OR</p>
              </div>-->

              <div class="col-9 col-md-10 pl-0">
                <div>
                  <div
                    class="d-flex align-items-center justify-content-center position-relative"
                    v-bind:class="[this.istwitter ==1 ? 'loading' : '', this.istwitter == 2 ? 'success' : '', this.istwitter ==3 ? 'error' : '', this.istwitter ==0 ? '' : '']"
                  >
                    <div class="input-box w-100">
                      <input
                        type="text"
                        class="sm-input-box"
                        v-on:focus="HideTheMessage()"
                        v-on:blur="handleTwitter()"
                        v-model="twitteruserurl"
                        :disabled="twittertextstatus"
                      />
                    </div>
                    <div class="ml-1 all-status">
                      <!-- ON SUCCESS -->
                      <div class="success-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <polyline
                            class="path check"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            points="100.2,40.2 51.5,88.8 29.8,67.5 "
                          />
                        </svg>
                      </div>

                      <!-- ON UNSUCCESS -->
                      <div class="unsuccess-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="34.4"
                            y1="37.9"
                            x2="95.8"
                            y2="92.3"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="95.8"
                            y1="38"
                            x2="34.4"
                            y2="92.2"
                          />
                        </svg>
                      </div>

                      <!-- ON LOADING -->
                      <div class="spinner-border loader" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                  <!-- <span
                  class="text-success text-center mt-1 error-msg"
                  >{{ showMessages.twitterMessage }}</span>-->
                </div>
              </div>
              <p
                v-if="istwitter != 5"
                class="light-text d-md-none text-truncate mb-0 pl-3"
              >Twitter eg: testuser</p>
            </div>

            <!-- AFTER VERIFIED BUT NOT SUBMITED START -->
            <div v-if="istwitter !== 5" class="d-none row pb-4 mx-0">
              <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                <div class="btn twitter-btn overflow-hidden" title="Twitter">
                  <img
                    src="@/assets/img/svg/twitter-brands.svg"
                    height="35"
                    width="35"
                    alt="twitter"
                  />
                </div>
              </div>
              <div class="col-9 col-md-10 px-2 social_link_verified verified_twitter">
                <div class="w-100 d-flex align-items-center justify-content-between">
                  <div class>{{ showMessages.twitterMessage }}</div>
                  <div class="p_value p_value_twitter">
                    <span>5</span>%
                  </div>
                </div>
              </div>
            </div>

            <!-- AFTER VERIFIED START -->
            <span
              v-if="istwitter == 5"
              class="light-text d-none d-md-block text-truncate"
            >Twitter eg: testuser</span>
            <div v-if="istwitter == 5" class="row pb-4 center-new">
              <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                <div class="btn twitter-btn overflow-hidden" title="Twitter">
                  <img
                    src="@/assets/img/svg/twitter-brands.svg"
                    height="35"
                    width="35"
                    alt="twitter"
                  />
                </div>
              </div>
              <div class="col-9 col-md-10 px-2 social_link_verified verified_twitter">
                <div class="w-100 d-flex align-items-center justify-content-between">
                  <div class>Details has been already captured</div>
                  <div class="p_value p_value_twitter">
                    <span>{{ showPonits.twitterPoint }}</span>%
                  </div>
                </div>
              </div>
              <span
                v-if="istwitter == 5"
                class="light-text d-md-none text-truncate"
              >Twitter eg: testuser</span>
            </div>

            <!-- AFTER VERIFIED END -->
            <!-- SOCIAL MEDIA (Twitter) END -->
          </div>

          <div class="col-lg-6">
            <!-- SOCIAL MEDIA (LinkedIn) START -->
            <!-- LINKEDIN NEW SECTION(IF LOGIN ERROR) START-->
            <span v-if="islinkedin != 5" class="light-text d-none d-md-block text-truncate">
              Linkedin eg:
              https://www.linkedin.com/in/testuser/
            </span>
            <div v-if="islinkedin != 5" class="row pb-4">
              <div class="col-3 col-md-2 pr-0">
                <div class="d-none d-md-block"></div>
                <div class="btn linkedIn-btn overflow-hidden" title="LinkedIn">
                  <img
                    src="@/assets/img/svg/linkedin-in-brands.svg"
                    height="30"
                    width="30"
                    alt="linkedIn"
                  />
                </div>
              </div>

              <div class="col-9 col-md-10 pl-0">
                <div>
                  <div
                    class="d-flex align-items-center justify-content-center position-relative"
                    v-bind:class="[this.islinkedin ==1 ? 'loading' : '', this.islinkedin ==2 ? 'success' : '', this.islinkedin ==3 ? 'error' : '', this.islinkedin ==0 ? '' : '']"
                  >
                    <div class="full-input-box">
                      <input
                        type="text"
                        class="sm-input-box"
                        v-on:focus="HideTheMessage()"
                        v-on:blur="handleLinkedin()"
                        v-model="linkedinuserurl"
                      />
                    </div>
                    <div class="ml-1 all-status">
                      <!-- ON SUCCESS -->
                      <div class="success-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <polyline
                            class="path check"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            points="100.2,40.2 51.5,88.8 29.8,67.5 "
                          />
                        </svg>
                      </div>

                      <!-- ON UNSUCCESS -->
                      <div class="unsuccess-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="34.4"
                            y1="37.9"
                            x2="95.8"
                            y2="92.3"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="95.8"
                            y1="38"
                            x2="34.4"
                            y2="92.2"
                          />
                        </svg>
                      </div>

                      <!-- ON LOADING -->
                      <div class="spinner-border loader" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                  <!-- <p class="text-success text-center mt-1 small">{{ showMessages.linkedinMessage }}</p> -->
                </div>
              </div>

              <span v-if="islinkedin != 5" class="light-text d-md-none text-truncate pl-3">
                Linkedin eg:
                https://www.linkedin.com/in/testuser/
              </span>
            </div>

            <!-- AFTER VERIFIED BUT SUBMITED START -->
            <div class="d-none col-12">
              <!-- v-if="islinkedin !== 5 && LinkedInObject.linkedin_is_submitted === 2" -->
              <div class="row pb-4">
                <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                  <div class="btn linkedIn-btn overflow-hidden" title="Linkedin">
                    <img
                      src="@/assets/img/svg/linkedin-in-brands.svg"
                      height="30"
                      width="30"
                      alt="linkedIn"
                    />
                  </div>
                </div>
                <div class="col-9 col-md-10 px-2 social_link_verified verified_linkedIn">
                  <div class>{{ showMessages.linkedinMessage }}</div>
                </div>
              </div>
            </div>

            <!-- AFTER VERIFIED START -->
            <span v-if="islinkedin == 5" class="light-text d-none d-md-block text-truncate">
              Linkedin eg:
              https://www.linkedin.com/in/testuser/
            </span>
            <div v-if="islinkedin == 5" class="row pb-4 center-new">
              <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                <div class="btn linkedIn-btn overflow-hidden" title="Linkedin">
                  <img
                    src="@/assets/img/svg/linkedin-in-brands.svg"
                    height="30"
                    width="30"
                    alt="linkedIn"
                  />
                </div>
              </div>
              <div class="col-9 col-md-10 px-2 social_link_verified verified_linkedIn">
                <div class="w-100 d-flex align-items-center justify-content-between">
                  <div class>Details has been already captured</div>
                  <div class="p_value p_value_linkedin">
                    <span>{{ showPonits.linkedinPoint }}</span>%
                  </div>
                </div>
              </div>
              <span v-if="islinkedin == 5" class="light-text d-md-none pl-2 text-truncate">
                Linkedin eg:
                https://www.linkedin.com/in/testuser/
              </span>
            </div>

            <!-- LINKEDIN NEW SECTION(IF LOGIN ERROR) END-->
            <!-- SOCIAL MEDIA (LinkedIn) END -->
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <!-- SOCIAL MEDIA (SpanChat) START -->
            <span
              v-if="issnapchat !== 5"
              class="light-text d-none d-md-block text-truncate"
            >Snapchat eg: testuser</span>
            <div v-if="issnapchat !== 5" class="row pb-4">
              <div class="col-3 col-md-2 pr-0">
                <div class="d-none d-md-block"></div>
                <div class="btn snapChat-btn overflow-hidden" title="Snapchat">
                  <img
                    src="@/assets/img/svg/snapchat-ghost-brands.svg"
                    height="35"
                    width="35"
                    alt="spanChat"
                  />
                </div>
              </div>

              <div class="col-9 col-md-10 pl-0">
                <div>
                  <div
                    class="d-flex align-items-center justify-content-center position-relative"
                    v-bind:class="[this.issnapchat ==1 ? 'loading' : '', this.issnapchat ==2 ? 'success' : '', this.issnapchat ==3 ? 'error' : '', this.issnapchat ==0 ? '' : '']"
                  >
                    <div class="full-input-box">
                      <input
                        type="text"
                        class="sm-input-box"
                        v-on:focus="HideTheMessage()"
                        v-on:blur="handleSnap()"
                        v-model="snapuserurl"
                      />
                    </div>
                    <div class="ml-1 all-status">
                      <!-- ON SUCCESS -->
                      <div class="success-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <polyline
                            class="path check"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            points="100.2,40.2 51.5,88.8 29.8,67.5 "
                          />
                        </svg>
                      </div>

                      <!-- ON UNSUCCESS -->
                      <div class="unsuccess-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="34.4"
                            y1="37.9"
                            x2="95.8"
                            y2="92.3"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="95.8"
                            y1="38"
                            x2="34.4"
                            y2="92.2"
                          />
                        </svg>
                      </div>

                      <!-- ON LOADING -->
                      <div class="spinner-border loader" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                v-if="issnapchat !== 5"
                class="light-text d-md-none text-truncate pl-3"
              >Snapchat eg: testuser</span>
            </div>

            <!-- AFTER VERIFIED BUT NOT SUBMITED START -->
            <div class="d-none col-12">
              <!-- v-if="issnapchat !== 5 && SnapchatObject.snapchat_is_submitted === 2" -->
              <div class="row pb-4">
                <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                  <div class="btn snapChat-btn overflow-hidden" title="Snapchat">
                    <img
                      src="@/assets/img/svg/snapchat-ghost-brands.svg"
                      height="35"
                      width="35"
                      alt="spanChat"
                    />
                  </div>
                </div>
                <div class="col-9 col-md-10 px-2 social_link_verified verified_snapchat">
                  <div class>{{ showMessages.snapchatMessage }}</div>
                </div>
              </div>
            </div>
            <!-- AFTER VERIFIED START -->
            <span
              v-if="issnapchat==5"
              class="light-text d-none d-md-block text-truncate"
            >Snapchat eg: testuser</span>
            <div v-if="issnapchat==5" class="row pb-4 center-new">
              <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                <div class="btn snapChat-btn overflow-hidden" title="Snapchat">
                  <img
                    src="@/assets/img/svg/snapchat-ghost-brands.svg"
                    height="35"
                    width="35"
                    alt="spanChat"
                  />
                </div>
              </div>
              <div class="col-9 col-md-10 px-2 social_link_verified verified_snapchat">
                <div class="w-100 d-flex align-items-center justify-content-between">
                  <div class>Details has been already captured</div>
                  <div class="p_value p_value_snapchat">
                    <span>{{ showPonits.snapchatPoint }}</span>%
                  </div>
                </div>
              </div>
              <span
                v-if="issnapchat==5"
                class="light-text d-md-none pl-2 text-truncate"
              >Snapchat eg: testuser</span>
            </div>

            <!-- AFTER VERIFIED END -->

            <!-- SOCIAL MEDIA (SpanChat) END -->
          </div>

          <div class="col-lg-6">
            <!-- SOCIAL MEDIA (WeChat) START -->
            <span
              v-if="iswe != 5"
              class="light-text d-none d-md-block text-truncate"
            >Wechat eg: testuser</span>
            <div v-if="iswe != 5" class="row pb-4">
              <div class="col-3 col-md-2 pr-0">
                <div class="d-none d-md-block"></div>
                <div class="btn weChat-btn overflow-hidden" title="Wechat">
                  <img src="@/assets/img/svg/weixin-brands.svg" height="35" width="35" alt="weChat" />
                </div>
              </div>

              <div class="col-9 col-md-10 pl-0">
                <div>
                  <div
                    class="d-flex align-items-center justify-content-center position-relative"
                    v-bind:class="[this.iswe == 1 ? 'loading' : '', this.iswe == 2 ? 'success' : '', this.iswe ==3 ? 'error' : '', this.iswe ==0 ? '' : '']"
                  >
                    <div class="full-input-box">
                      <input
                        type="text"
                        class="sm-input-box"
                        v-on:focus="HideTheMessage()"
                        v-on:blur="handleWe()"
                        v-model="weuserurl"
                      />
                    </div>
                    <div class="ml-1 all-status">
                      <!-- ON SUCCESS -->
                      <div class="success-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <polyline
                            class="path check"
                            fill="none"
                            stroke="#73AF55"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            points="100.2,40.2 51.5,88.8 29.8,67.5 "
                          />
                        </svg>
                      </div>

                      <!-- ON UNSUCCESS -->
                      <div class="unsuccess-check">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 130.2 130.2"
                        >
                          <circle
                            class="path circle"
                            fill="#e1e1e1"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-miterlimit="10"
                            cx="65.1"
                            cy="65.1"
                            r="62.1"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="34.4"
                            y1="37.9"
                            x2="95.8"
                            y2="92.3"
                          />
                          <line
                            class="path line"
                            fill="none"
                            stroke="#D06079"
                            stroke-width="6"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="95.8"
                            y1="38"
                            x2="34.4"
                            y2="92.2"
                          />
                        </svg>
                      </div>

                      <!-- ON LOADING -->
                      <div class="spinner-border loader" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span
                v-if="iswe != 5"
                class="light-text d-md-none text-truncate pl-3"
              >Wechat eg: testuser</span>
            </div>

            <div class="d-none row pb-4 mx-0">
              <!-- v-if="iswe !== 5 && this.WechatObject.wechat_is_submitted == 2" -->
              <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                <div class="btn weChat-btn overflow-hidden" title="Wechat">
                  <img src="@/assets/img/svg/weixin-brands.svg" height="35" width="35" alt="weChat" />
                </div>
              </div>
              <div class="col-9 col-md-10 px-2 social_link_verified verified_wechat">
                <div class>{{ showMessages.wechatMessage }}</div>
              </div>
            </div>

            <!-- AFTER VERIFIED BUT NOT SUBMITED START -->
            <span
              v-if="iswe == 5"
              class="light-text d-none d-md-block text-truncate"
            >Wechat eg: testuser</span>
            <div v-if="iswe == 5" class="row pb-4 center-new">
              <div class="col-3 col-md-2 mb-md-0 pl-0 pr-0 pr-md-0 cus_verified_btn">
                <div class="btn weChat-btn overflow-hidden" title="Wechat">
                  <img src="@/assets/img/svg/weixin-brands.svg" height="35" width="35" alt="weChat" />
                </div>
              </div>
              <div class="col-9 col-md-10 px-2 social_link_verified verified_wechat">
                <div class="w-100 d-flex align-items-center justify-content-between">
                  <div class>Details has been already captured</div>
                  <div class="p_value p_value_wechat">
                    <span>{{ showPonits.wechatPoint }}</span>%
                  </div>
                </div>
              </div>
              <span
                v-if="iswe == 5"
                class="pl-2 light-text d-md-none text-truncate"
              >Wechat eg: testuser</span>
            </div>

            <!-- AFTER VERIFIED END -->
          </div>
        </div>

        <p class="text-center text-danger mt-3">{{showMessages.FinalErrorMessage}}</p>
        <div
          v-if="submitOneActive"
          class="error-alert pb-3"
        >Please fill out at least 1 of the fields</div>
        <div
          v-if="isfacebook==5 && istwitter==5 && isinstagram==5 && islinkedin==5 && issnapchat==5 && iswe==5"
        ></div>
        <div class="submit-btn" v-else @click="saveFinalData(true)">SUBMIT</div>
      </div>
    </div>
    <footer class="py-4">
      <p class="grey_text font-weight-bold text-center mb-0" style="font-size: 14px;">
        &copy; Copyright 2020. DAMAC Properties. All rights
        reserved.
      </p>
    </footer>
  </section>
  <section class="container px-0" v-else-if="validUser==0">
    <p class="txtcolor text-center">Validating user</p>
  </section>
  <section class="container px-0" v-else>
    <p class="txtcolor text-center">You are not Authorize</p>
  </section>
</template>

<script>
import axios from "axios";
import { BASEURL } from "@/config/index";

let BaseURL = BASEURL;
let instagramClientId = "515062982485644";
let linkedInclientId = "81tbata79394oa";
//  isSuccess: false,
// email: "",
// first_name: "",
// middle_name: "",
// last_name: "",
// profileUrl: "",
// gender: "",
// address: "",
// socialLink: "",
// accountType: "facebook",
// uniqueId: "",
// createdAtSocial: "",
// socialId: "",
// location: "",
// socialScreenName: ""
/////
// email: "",
// first_name: "",
// middle_name: "",
// last_name: "",
// profileUrl: "",
// gender: "",
// address: "",
// socialLink: "",
// accountType: "linkedin",
// uniqueId: "",
// createdAtSocial: "",
// socialId: "",
// location: "",
// socialScreenName: ""
export default {
  name: "Index",
  data() {
    return {
      submitOneActive: false,
      validUser: 0,
      cid: null,
      flag: {
        isBtnFacebook: 0,
        isBtnTwitter: 0,
        isBtnInstagram: 0,
        isBtnLinkedin: 0
      },
      issnapchat: 0,
      issubmit: false,
      iswe: 0,
      snapuserurl: "",
      weuserurl: "",
      myWindow: "",
      fbuserurl: "",
      twitteruserurl: "",
      linkedinuserurl: "",
      instuserurl: "",
      polling: null,
      fb_user_name: "User Name",
      fb_profile_url: "./assets/img/profile-img.png",
      inst_user_name: "User Name",
      inst_profile_url: "./assets/img/profile-img.png",
      twitter_user_name: "",
      twitter_profile_url: "./assets/img/profile-img.png",
      linkedin_user_name: "User Name",
      linkedin_profile_url: "./assets/img/profile-img.png",
      isfacebook: 0,
      isprovider: "",
      isinstagram: 0,
      istwitter: 0,
      islinkedin: 0,
      linkedintextstatus: false,
      twittertextstatus: false,
      instagramtextstatus: false,
      fbSignInParams: {
        scope: "email,user_likes,user_link",
        return_scopes: true
      },
      showMessages: {
        facebookMessage: "",
        instagramMessage: "",
        twitterMessage: "",
        linkedinMessage: "",
        snapchatMessage: "",
        wechatMessage: "",
        FinalErrorMessage: ""
      },
      showPonits: {
        facebookPoint: 0,
        instagramPoint: 0,
        twitterPoint: 0,
        linkedinPoint: 0,
        snapchatPoint: 0,
        wechatPoint: 0,
        TotalPoint: 0
      },
      FacebookObject: {
        facebook_is_submitted: 0,
        isSuccess: false,
        isManualLink: false
        // facebook_id: "",
        // facebook_first_name: "",
        // facebook_last_name: "",
        // facebook_middle_name: "",
        // facebook_email: "",
        // facebook_gender: "",
        // facebook_profile_pic: "",
        // facebook_link: "",
        // facebook_hometown: "",
        // facebook_facebook_url: "",
        // // BN
        // facebook_social_link: "",
        // facebook_social_manual_link: "",
        // facebook_is_success: false
      },
      InstaObject: {
        instagram_is_submitted: 0,
        isSuccess: false,
        isManualLink: false

        // instagram_id: "",
        // instagram_account_type: "",
        // instagram_username: "",
        // instagram_instagram_id: "",
        // // BN
        // instagram_social_link: "",
        // instagram_social_manual_link: "",
        // instagram_is_success: false
      },
      TwitterObject: {
        twitter_is_submitted: 0,
        isSuccess: false,
        isManualLink: false

        // twitter_id: "",
        // twitter_name: "",
        // twitter_screen_name: "",
        // twitter_location: "",
        // twitter_description: "",
        // twitter_followers_count: "",
        // twitter_friends_count: "",
        // twitter_created_at: "",
        // twitter_profile_image_url_https: "",
        // twitter_twitter_id: "",
        // // BN
        // twitter_social_link: "",
        // twitter_social_manual_link: "",
        // twitter_is_success: false
      },
      LinkedInObject: {
        linkedin_is_submitted: 0,
        isSuccess: false,
        isManualLink: false

        // linkedin_id: "",
        // linkedin_first_name: "",
        // linkedin_last_name: "",
        // linkedin_maiden_name: "",
        // linkedin_location: "",
        // linkedin_public_profile_url: "",
        // linkedin_picture_url: "",
        // linkedin_linkedin_url: "",
        // // BN
        // linkedin_social_link: "",
        // linkedin_social_manual_link: "",
        // linkedin_is_success: false
      },
      SnapchatObject: {
        snapchat_is_submitted: 0,
        isSuccess: false,
        isManualLink: false

        // snapchat_id: "",
        // // BN
        // snapchat_social_link: "",
        // snapchat_social_manual_link: "",
        // snapchat_is_success: false
      },
      WechatObject: {
        wechat_is_submitted: 0,
        isSuccess: false,
        isManualLink: false

        // wechat_id: "",
        // // BN
        // wechat_social_link: "",
        // wechat_social_manual_link: "",
        // wechat_is_success: false
      }
    };
  },
  components: {},
  beforeMount() {
    const { cid } = this.$route.query;
    this.cid = cid;
    this.verifyCID();
  },
  mounted() {},
  methods: {
    HideTheMessage: function() {
      this.showMessages.FinalErrorMessage = "";
    },
    verifyCID: function() {
      axios
        .post(`${BaseURL}/verifyCID`, {
          cid: this.cid
        })
        .then(response => {
          // console.log(response);
          if (response && response.data && response.data["status"]) {
            this.validUser = 1;
            this.getUserInfo();
          } else {
            this.validUser = 2;
          }
        });
    },
    getUserInfo: function() {
      let loader = this.$loading.show();

      axios
        .post(`${BaseURL}/get-user-info`, { cid: this.cid })
        .then(user_info => {
          // console.log("user_info", user_info);
          if (user_info.data.status && user_info.data.Records) {
            let mainObj = user_info.data.Records;
            if (mainObj.isSubmitActive == "0") {
              this.issubmit = true;
            }

            //Facebook
            if (
              mainObj.Facebook.facebook_is_submitted == 2 &&
              mainObj.Facebook.facebook_is_success
            ) {
              this.isfacebook = 5;
              this.showPonits.facebookPoint = 5;
            } else if (
              mainObj.Facebook.facebook_is_submitted == 2 &&
              mainObj.Facebook.facebook_social_manual_link.length > 0
            ) {
              this.isfacebook = 5;
              this.showPonits.facebookPoint = 5;
            } else if (mainObj.Facebook.facebook_is_submitted == 1) {
              // SHOW MESSAGE
              this.showMessages.facebookMessage =
                "You already provided details for this, Kindly submit to get your coupon code";
              // this.FacebookObject.facebook_is_submitted = 2;
              // this.fbuserurl = mainObj.Facebook.facebook_social_manual_link;
            }

            //Instagram
            if (
              mainObj.Instagram.instagram_is_submitted == 2 &&
              mainObj.Instagram.instagram_is_success
            ) {
              this.isinstagram = 5;
              this.showPonits.instagramPoint = 5;
            } else if (
              mainObj.Instagram.instagram_is_submitted == 2 &&
              mainObj.Instagram.instagram_social_manual_link.length > 0
            ) {
              this.isinstagram = 5;
              this.showPonits.instagramPoint = 5;
            } else if (mainObj.Instagram.instagram_is_submitted == 1) {
              this.showMessages.instagramMessage =
                "You already provided details for this, Kindly submit to get your coupon code";
              // this.InstaObject.instagram_is_submitted = 2;
              // this.instuserurl = mainObj.Instagram.instagram_social_manual_link;
            }

            //Twitter
            if (
              mainObj.Twitter.twitter_is_submitted == 2 &&
              mainObj.Twitter.twitter_is_success
            ) {
              this.istwitter = 5;
              this.showPonits.twitterPoint = 5;
            } else if (
              mainObj.Twitter.twitter_is_submitted == 2 &&
              mainObj.Twitter.twitter_social_manual_link.length > 0
            ) {
              this.istwitter = 5;
              this.showPonits.twitterPoint = 5;
            } else if (mainObj.Twitter.twitter_is_submitted == 1) {
              this.showMessages.twitterMessage =
                "You already provided details for this, Kindly submit to get your coupon code";
              // this.TwitterObject.twitter_is_submitted = 2;
              // this.twitteruserurl = mainObj.Twitter.twitter_social_manual_link;
            }

            //Linked In
            if (
              mainObj.Linkedin.linkedin_is_submitted == 2 &&
              mainObj.Linkedin.linkedin_is_success
            ) {
              this.islinkedin = 5;
              this.showPonits.linkedinPoint = 5;
            } else if (
              mainObj.Linkedin.linkedin_is_submitted == 2 &&
              mainObj.Linkedin.linkedin_social_manual_link.length > 0
            ) {
              this.islinkedin = 5;
              this.showPonits.linkedinPoint = 5;
            } else if (mainObj.Linkedin.linkedin_is_submitted == 1) {
              this.showMessages.linkedinMessage =
                "You already provided details for this, Kindly submit to get your coupon code";
              // this.LinkedInObject.linkedin_is_submitted = 2;
              // this.linkedinuserurl =
              //   mainObj.Linkedin.linkedin_social_manual_link;
            }

            //Snapchat
            if (
              mainObj.Snapchat.snapchat_is_submitted == 2 &&
              mainObj.Snapchat.snapchat_is_success
            ) {
              this.issnapchat = 5;
              this.showPonits.snapchatPoint = 5;
            } else if (
              mainObj.Snapchat.snapchat_is_submitted == 2 &&
              mainObj.Snapchat.snapchat_social_manual_link.length > 0
            ) {
              this.issnapchat = 5;
              this.showPonits.snapchatPoint = 5;
            } else if (mainObj.Snapchat.snapchat_is_submitted == 1) {
              this.showMessages.snapchatMessage =
                "You already provided details for this, Kindly submit to get your coupon code";
              // this.SnapchatObject.snapchat_is_submitted = 2;
              // this.snapuserurl = mainObj.Snapchat.snapchat_social_manual_link;
            }

            //We chat
            if (
              mainObj.Wechat.wechat_is_submitted == 2 &&
              mainObj.Wechat.wechat_is_success
            ) {
              this.iswe = 5;
              Object.keys(this.showPonits).map(x => {
                x !== "TotalPoint"
                  ? (this.showPonits.TotalPoint += this.showPonits[x])
                  : "";
                if (this.showPonits.TotalPoint >= 25) {
                  this.showPonits.wechatPoint = 0;
                } else {
                  this.showPonits.wechatPoint = 5;
                }
              });
            } else if (
              mainObj.Wechat.wechat_is_submitted == 2 &&
              mainObj.Wechat.wechat_social_manual_link.length > 0
            ) {
              this.iswe = 5;
              Object.keys(this.showPonits).map(x => {
                x !== "TotalPoint"
                  ? (this.showPonits.TotalPoint += this.showPonits[x])
                  : "";
                if (this.showPonits.TotalPoint >= 25) {
                  this.showPonits.wechatPoint = 0;
                } else {
                  this.showPonits.wechatPoint = 5;
                }
              });
            } else if (mainObj.Wechat.wechat_is_submitted == 1) {
              this.showMessages.wechatMessage =
                "You already provided details for this, Kindly submit to get your coupon code";
              // this.WechatObject.wechat_is_submitted = 2;
              // this.weuserurl = mainObj.Wechat.wechat_social_manual_link;
            }
          } else {
            // console.log("No data found from user info api", user_info);
          }
          // console.log("mainObj", mainObj);
          // console.log("isfacebook", this.isfacebook);
          // console.log("isinstagram", this.isinstagram);
          // console.log("istwitter", this.istwitter);
          // console.log("islinkedin", this.islinkedin);
          // console.log("issnapchat", this.issnapchat);
          // console.log("iswe", this.iswe);
          setTimeout(() => loader.hide(), 1000);
        })
        .catch(err => {
          // console.log("err In get user info APi", err)
          loader.hide();
        });
    },
    // saveFinalData: function(finalSubmit, loader) {
    saveFinalData: function(finalSubmit) {
      this.HideTheMessage();
      this.submitOneActive = false;

      if (
        this.FacebookObject.facebook_is_submitted == 0 &&
        this.isfacebook !== 3 &&
        this.InstaObject.instagram_is_submitted == 0 &&
        this.isinstagram !== 3 &&
        this.TwitterObject.twitter_is_submitted == 0 &&
        this.istwitter !== 3 &&
        this.LinkedInObject.linkedin_is_submitted == 0 &&
        this.islinkedin !== 3 &&
        this.SnapchatObject.snapchat_is_submitted == 0 &&
        this.issnapchat !== 3 &&
        this.WechatObject.wechat_is_submitted == 0 &&
        this.iswe !== 3
      ) {
        this.showMessages.FinalErrorMessage =
          "Please fill out at least 1 of the fields";
        // setTimeout(() => {
        //   this.showMessages.FinalErrorMessage = "";
        // }, 2000);
      } else if (
        this.isinstagram == 3 ||
        this.istwitter == 3 ||
        this.isfacebook == 3 ||
        this.iswe == 3 ||
        this.issnapchat == 3 ||
        this.islinkedin == 3
      ) {
        this.showMessages.FinalErrorMessage = "Cannot submit Invalid data";
        // setTimeout(() => {
        //   this.showMessages.FinalErrorMessage = "";
        // }, 2000);
      } else if (this.issubmit) {
        let loader = this.$loading.show();

        let socialMediaString = "";
        let payload = {
          cid: this.cid,
          // facebook: this.FacebookObject,
          // twitter: this.TwitterObject,
          // instagram: this.InstaObject,
          // linkedin: this.LinkedInObject,
          // snapchat: this.SnapchatObject,
          // wechat: this.WechatObject,
          finalSubmit
        };

        if (this.FacebookObject.isSuccess) {
          payload["facebook"] = this.FacebookObject;
          payload.facebook["facebook_is_submitted"] = 2;
          socialMediaString.length === 0
            ? (socialMediaString += "facebook")
            : (socialMediaString += ", facebook");
        }
        if (this.InstaObject.isSuccess) {
          payload["instagram"] = this.InstaObject;
          payload.instagram["instagram_is_submitted"] = 2;
          socialMediaString.length === 0
            ? (socialMediaString += "instagram")
            : (socialMediaString += ", instagram");
        }
        if (this.LinkedInObject.isSuccess) {
          payload["linkedin"] = this.LinkedInObject;
          payload.linkedin["linkedin_is_submitted"] = 2;
          socialMediaString.length === 0
            ? (socialMediaString += "linkedin")
            : (socialMediaString += ", linkedin");
        }
        if (this.TwitterObject.isSuccess) {
          payload["twitter"] = this.TwitterObject;
          payload.twitter["twitter_is_submitted"] = 2;
          socialMediaString.length === 0
            ? (socialMediaString += "twitter")
            : (socialMediaString += ", twitter");
        }
        if (this.SnapchatObject.isSuccess) {
          payload["snapchat"] = this.SnapchatObject;
          payload.snapchat["snapchat_is_submitted"] = 2;
          socialMediaString.length === 0
            ? (socialMediaString += "snapchat")
            : (socialMediaString += ", snapchat");
        }
        if (this.WechatObject.isSuccess) {
          payload["wechat"] = this.WechatObject;
          payload.wechat["wechat_is_submitted"] = 2;
          socialMediaString.length === 0
            ? (socialMediaString += "wechat")
            : (socialMediaString += ", wechat");
        }
        axios
          .post(
            // `${BaseURL}/saveData`
            // `${BaseURL}/sendsociallead`,
            `${BaseURL}/insertsociallead`,
            payload
          )
          .then(
            response => {
              if (response && response.data && response.data["status"]) {
                if (finalSubmit) {
                  //this.$router.push({name:"/thankyou", params:{5}});
                  let discount = 0;
                  let expiry = 0;
                  if (response.data["discount"] && response.data["expiry"]) {
                    discount = response.data["discount"];
                    expiry = response.data["expiry"];
                    // console.log('discount :', discount);
                    this.$router.push({
                      name: "Thankyou",
                      params: {
                        discount: discount,
                        expiry: expiry,
                        cid: this.cid,
                        socialMediaString
                      }
                    });
                  }
                } else {
                }
              } else {
                // console.log("Api error in saveFinalData");
              }
              setTimeout(() => loader.hide(), 1000);
              //
            },
            error => {
              // console.log(error);
              setTimeout(() => loader.hide(), 1000);
            }
          );
      }
      // else {
      //   //  alert("Please fill out at least 1 of the fields");
      //   this.submitOneActive = true;
      // }
    },
    saveData: function(finalSubmit) {
      return false;

      this.HideTheMessage();
      this.submitOneActive = false;
      if (
        this.FacebookObject.facebook_is_submitted == 0 &&
        this.isfacebook !== 3 &&
        this.InstaObject.instagram_is_submitted == 0 &&
        this.isinstagram !== 3 &&
        this.TwitterObject.twitter_is_submitted == 0 &&
        this.istwitter !== 3 &&
        this.LinkedInObject.linkedin_is_submitted == 0 &&
        this.islinkedin !== 3 &&
        this.SnapchatObject.snapchat_is_submitted == 0 &&
        this.issnapchat !== 3 &&
        this.WechatObject.wechat_is_submitted == 0 &&
        this.iswe !== 3
      ) {
        this.showMessages.FinalErrorMessage =
          "Please fill out at least 1 of the fields";
        // setTimeout(() => {
        //   this.showMessages.FinalErrorMessage = "";
        // }, 2000);
      } else if (
        this.isinstagram == 3 ||
        this.istwitter == 3 ||
        this.isfacebook == 3 ||
        this.iswe == 3 ||
        this.issnapchat == 3 ||
        this.islinkedin == 3
      ) {
        this.showMessages.FinalErrorMessage = "Cannot submit Invalid data";
        // setTimeout(() => {
        //   this.showMessages.FinalErrorMessage = "";
        // }, 2000);
      } else if (this.issubmit) {
        let payload = {
          cid: this.cid
        };
        if (this.FacebookObject.isSuccess) {
          payload["facebook"] = this.FacebookObject;
        }
        if (this.InstaObject.isSuccess) {
          payload["instagram"] = this.InstaObject;
        }
        if (this.LinkedInObject.isSuccess) {
          payload["linkedin"] = this.LinkedInObject;
        }

        if (this.TwitterObject.isSuccess) {
          payload["twitter"] = this.TwitterObject;
        }
        if (this.SnapchatObject.isSuccess) {
          payload["snapchat"] = this.SnapchatObject;
        }
        if (this.WechatObject.isSuccess) {
          payload["wechat"] = this.WechatObject;
        }
        let loader = null;
        finalSubmit ? (loader = this.$loading.show()) : "";
        axios
          .post(
            `${BaseURL}/saveData`,
            payload
            // {
            //   cid: this.cid,
            //   facebook: this.FacebookObject,
            //   twitter: this.TwitterObject,
            //   instagram: this.InstaObject,
            //   linkedin: this.LinkedInObject,
            //   snapchat: this.SnapchatObject,
            //   wechat: this.WechatObject,
            //   // finalSubmit
            // }
          )
          .then(
            response => {
              // console.log(response);
              if (response && response.data && response.data["status"]) {
                // if (finalSubmit) {
                //   //this.$router.push({name:"/thankyou", params:{5}});
                //   let discount = 0;
                //   let expiry = 0;
                //   if (response.data["discount"]) {
                //     discount = response.data["discount"];
                //   }
                //   if (response.data["expiry"]) {
                //     expiry = response.data["expiry"];
                //   }
                //   this.$router.push({
                //     name: "Thankyou",
                //     params: { discount: discount, expiry: expiry }
                //   });
                // } else {
                // }
              } else {
                // console.log("Api error");
              }
            },
            error => {
              // console.log(error);
            }
          )
          .finally(() => {
            console.log("finalSubmit :", finalSubmit);
            if (finalSubmit) {
              setTimeout(() => {
                this.saveFinalData(finalSubmit, loader);
              }, 1500);
            }
          });
      } else {
        //  alert("Please fill out at least 1 of the fields");
        this.submitOneActive = true;
      }
    },
    handleWe: function() {
      this.HideTheMessage();
      let url = this.weuserurl;
      this.WechatObject = {
        wechat_is_submitted: 0,
        isSuccess: false,
        isManualLink: false
      };
      if (url != "") {
        if (url.length >= 4 && url.length <= 100) {
          //this.url = 'http://' + this.url;
          this.iswe = 2;
          this.issubmit = true;
          // this.WechatObject.socialLink = this.weuserurl;

          this.WechatObject["isSuccess"] = true;
          this.WechatObject["wechat_is_submitted"] = 1;
          this.WechatObject["isManualLink"] = true;
          this.WechatObject["wechat_id"] = this.weuserurl;
          this.WechatObject["wechat_social_manual_link"] = this.weuserurl;
          // this.saveData(false);
        } else {
          this.iswe = 3;
        }
      } else {
        this.iswe = 0;
      }
    },
    handleSnap: function() {
      this.SnapchatObject = {
        snapchat_is_submitted: 0,
        isSuccess: false,
        isManualLink: false
      };
      this.HideTheMessage();
      let url = this.snapuserurl;
      let len = url.length;
      if (url != "") {
        if (len >= 4 && url.length <= 100) {
          this.issnapchat = 2;
          this.issubmit = true;
          // this.SnapchatObject.socialLink = this.snapuserurl;

          this.SnapchatObject["isSuccess"] = true;
          this.SnapchatObject["snapchat_is_submitted"] = 1;
          this.SnapchatObject["isManualLink"] = true;
          this.SnapchatObject["snapchat_id"] = this.snapuserurl;
          this.SnapchatObject["snapchat_social_manual_link"] = this.snapuserurl;
          // this.saveData(false);
        } else {
          this.issnapchat = 3;
        }
      } else {
        this.issnapchat = 0;
      }
    },
    handleLinkedin: function() {
      this.HideTheMessage();
      this.LinkedInObject = {
        linkedin_is_submitted: 0,
        isSuccess: false,
        isManualLink: false
      };
      let url = this.linkedinuserurl;
      if (url != "") {
        let regex = /^(?:(?:http|https):\/\/)?(?:www.|m.)?linkedin.com\/(?!home.php)(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\.-]+)/;
        if (url.match(regex) && url.length <= 100) {
          this.islinkedin = 2;
          this.issubmit = true;
          // this.LinkedInObject.socialLink = this.linkedinuserurl;

          this.LinkedInObject["isSuccess"] = true;
          this.LinkedInObject["linkedin_is_submitted"] = 1;
          this.LinkedInObject["isManualLink"] = true;
          this.linkedintextstatus = true;
          this.LinkedInObject["linkedin_linkedin_url"] = this.linkedinuserurl;
          this.LinkedInObject[
            "linkedin_social_manual_link"
          ] = this.linkedinuserurl;

          // this.saveData(false);
        } else {
          this.islinkedin = 3;
        }
      } else {
        this.islinkedin = 0;
      }
    },
    handleTwitter: function() {
      this.TwitterObject = {
        twitter_is_submitted: 0,
        isSuccess: false,
        isManualLink: false
      };
      this.HideTheMessage();
      let url = this.twitteruserurl;

      if (url != "") {
        if (url.length >= 4 && url.length <= 100) {
          //this.url = 'http://' + this.url;
          this.istwitter = 2;
          // this.TwitterObject.socialLink = this.twitteruserurl;
          this.issubmit = true;

          this.TwitterObject["isSuccess"] = true;
          this.TwitterObject["twitter_is_submitted"] = 1;
          this.TwitterObject["isManualLink"] = true;
          this.TwitterObject["twitter_twitter_id"] = this.twitteruserurl;
          this.TwitterObject[
            "twitter_social_manual_link"
          ] = this.twitteruserurl;
          // this.saveData(false);
        } else {
          this.istwitter = 3;
        }
      } else {
        this.istwitter = 0;
      }
    },
    handleFacebook: function() {
      this.HideTheMessage();
      let url = this.fbuserurl;
      this.FacebookObject = {
        facebook_is_submitted: 0,
        isSuccess: false,
        isManualLink: false
      };
      if (url != "") {
        let regex = /^(?:(?:http|https):\/\/)?(?:www.|m.)?facebook.com\/(?!home.php)(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\.-]+)/;
        if (url.match(regex) && url.length <= 100) {
          //this.url = 'http://' + this.url;
          this.isfacebook = 2;

          if (this.isfacebook == 2) {
            this.FacebookObject["isSuccess"] = true;
            this.FacebookObject["isManualLink"] = true;
            this.FacebookObject["facebook_is_submitted"] = 1;
            this.FacebookObject["facebook_facebook_url"] = this.fbuserurl;
            this.FacebookObject["facebook_social_manual_link"] = this.fbuserurl;
            this.issubmit = true;
            // this.saveData(false);
          }
        } else {
          this.isfacebook = 3;
        }
      } else {
        this.isfacebook = 0;
      }
    },
    handleInstagram: function() {
      this.HideTheMessage();
      this.InstaObject = {
        instagram_is_submitted: 0,
        isSuccess: false,
        isManualLink: false
      };
      let url = this.instuserurl;
      if (url != "") {
        // let regex = /^(?:(?:http|https):\/\/)?(?:www.|m.)?instagram.com\/(?!home.php)(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\.-]+)/;
        let regex = /^[A-Za-z0-9_.]*$/;
        if (url.match(regex) && url.length <= 100) {
          this.isinstagram = 2;
          // this.InstaObject.socialLink = this.instuserurl;
          this.issubmit = true;

          this.InstaObject["isSuccess"] = true;
          this.InstaObject["instagram_is_submitted"] = 1;
          this.InstaObject["isManualLink"] = true;
          this.InstaObject["instagram_instagram_id"] = this.instuserurl;
          this.InstaObject["instagram_social_manual_link"] = this.instuserurl;
          // this.saveData(false);
        } else {
          this.isinstagram = 3;
        }
      } else {
        this.isinstagram = 0;
      }
    },

    /////////////////
    twitteronSignIn: function() {
      this.HideTheMessage();
      let url = `${BaseURL}/auth/twitter`;
      this.myWindow = window.open(url, "myWindow", "width=500,height=300");
      //this.myWindow.document.write("<h1>www.tutorialsplane.com</h1>");
      let that = this;
      this.polling = setInterval(function() {
        //console.log('In');
        // console.log(that.myWindow.location.href);
        let content = that.myWindow.document.documentElement.outerHTML;
        let currurl = that.myWindow.location.href;
        let arr = currurl.split(`${BaseURL}/auth/twitter`);
        if (arr.length >= 2) {
          let regex = /(<([^>]+)>)/gi;
          // console.log(content);
          try {
            let data = JSON.parse(content.replace(regex, ""));
            // console.log(data);
            that.istwitter = 4;
            that.flag.isBtnTwitter = 2;
            that.issubmit = true;
            that.twittertextstatus = true;
            that.twitter_user_name = data.username;
            that.twitter_profile_url = data.profile_picture;
            //console.log(that.inst_profile_url)
            clearInterval(that.polling);
            that.TwitterObject = {};

            that.twitteruserurl = data.username;

            that.TwitterObject["isSuccess"] = true;
            that.TwitterObject["twitter_is_submitted"] = 1;
            that.TwitterObject["isManualLink"] = false;
            that.TwitterObject["twitter_name"] = data.username || "";

            that.TwitterObject["twitter_profile_image_url_https"] =
              data["profile_picture"] || "";
            that.TwitterObject["twitter_is_success"] = true;
            that.TwitterObject[
              "twitter_social_link"
            ] = `https://twitter.com/${data.username}`;

            that.TwitterObject[
              "twitter_social_manual_link"
            ] = `https://twitter.com/${data.username}`;
            that.saveData(false);
            that.myWindow.close();
          } catch (e) {
            //clearInterval(that.polling)
            //that.myWindow.close();
            // console.log("Exception: ", e);
          }
        }
      }, 2000);
    },
    linkedInLogin: function() {
      this.HideTheMessage();
      clearInterval(this.polling);

      let url =
        "https://www.linkedin.com/oauth/v2/authorization?scope=r_liteprofile&client_id=" +
        linkedInclientId +
        `&redirect_uri=${BaseURL}/auth/linkedin&response_type=code`;
      this.myWindow = window.open(url, "myWindow", "width=500,height=300");
      //this.myWindow.document.write("<h1>www.tutorialsplane.com</h1>");
      let that = this;
      this.polling = setInterval(function() {
        // console.log("In", that.myWindow);
        // console.log(that.myWindow.location.href);
        let content = that.myWindow.document.documentElement.outerHTML;
        let currurl = that.myWindow.location.href;
        let arr = currurl.split(`${BaseURL}/auth/linkedin`);
        if (arr.length >= 2) {
          let regex = /(<([^>]+)>)/gi;
          // console.log(content);
          try {
            let data = JSON.parse(content.replace(regex, ""));
            // console.log(data);
            that.islinkedin = 4;
            that.flag.isBtnLinkedin = 2;
            that.linkedintextstatus = true;
            that.issubmit = true;

            that.linkedin_user_name = data.username;
            that.linkedin_profile_url = data.profile_picture;
            // console.log(that.inst_profile_url);
            clearInterval(that.polling);
            that.LinkedInObject = {};
            that.LinkedInObject["isSuccess"] = true;
            that.LinkedInObject["linkedin_is_submitted"] = 1;
            that.LinkedInObject["isManualLink"] = false;
            that.LinkedInObject["linkedin_first_name"] = data.username;
            that.LinkedInObject["linkedin_last_name"] = data.lastname;
            that.LinkedInObject["linkedin_picture_url"] = data.profile_picture;
            that.LinkedInObject["linkedin_is_success"] = true;

            that.saveData(false);
            that.myWindow.close();
          } catch (e) {
            clearInterval(that.polling);
            that.myWindow.close();
            // console.log("Exception: ", e);
          }
        }
      }, 2000);
    },
    instagramLogin: function() {
      this.HideTheMessage();
      clearInterval(this.polling);

      let instagramRedirectUri = `${BaseURL}/auth/instagram`;
      let url =
        "https://instagram.com/oauth/authorize/?client_id=" +
        instagramClientId +
        "&redirect_uri=" +
        instagramRedirectUri +
        "&response_type=code&scope=user_profile,user_media";
      this.myWindow = window.open(url, "myWindow", "width=500,height=300");
      // this.myWindow.document.write("<h1>www.tutorialsplane.com</h1>");
      let that = this;
      // console.log("In Instagram", this.myWindow);

      this.polling = setInterval(function() {
        // console.log("In dnfdnjvnfjn");
        let content = that.myWindow.document.documentElement.outerHTML;
        let currurl = that.myWindow.location.href;
        let arr = currurl.split(`${BaseURL}/auth/instagram`);
        // console.log("arr", arr);
        if (arr.length >= 2) {
          let regex = /(<([^>]+)>)/gi;
          // console.log(content);
          try {
            let data = JSON.parse(content.replace(regex, ""));
            // console.log(data);
            that.isinstagram = 4;
            that.issubmit = true;
            that.flag.isBtnInstagram = 2;
            that.instagramtextstatus = true;
            that.inst_user_name = data.username;
            //that.inst_profile_url = data.user.profile_picture;
            axios
              .get("https://www.instagram.com/" + data.username + "/?__a=1")
              .then(
                response => {
                  // console.log(response);
                  let jsondata = response.data;
                  var photoURL =
                    jsondata["graphql"]["user"]["profile_pic_url_hd"];
                  // console.log(photoURL);
                  that.inst_profile_url = photoURL;

                  that.InstaObject = {};
                  that.InstaObject["isSuccess"] = true;
                  that.InstaObject["instagram_is_submitted"] = 1;
                  that.InstaObject["isManualLink"] = false;

                  that.InstaObject["instagram_profile_url"] = photoURL;
                  that.InstaObject["instagram_username"] = data.username;
                  that.InstaObject["instagram_is_success"] = true;
                  that.InstaObject["instagram_account_type"] =
                    data.account_type;
                  that.InstaObject[
                    "instagram_social_link"
                  ] = `https://www.instagram.com/${data.username}`;
                  that.instuserurl = data.username;
                  that.InstaObject[
                    "instagram_social_manual_link"
                  ] = `https://www.instagram.com/${data.username}`;
                  that.saveData(false);
                },
                error => {
                  // console.log(error);
                }
              );

            // console.log(that.inst_profile_url);
            clearInterval(that.polling);

            //API call
            that.myWindow.close();
          } catch (e) {
            clearInterval(that.polling);
            that.myWindow.close();
            // console.log("Exception: ", e);
          }
        } else {
        }
      }, 2000);
    },
    closeWindow: function() {
      this.HideTheMessage();
      this.myWindow.close();
    },
    onSignInSuccess(response) {
      this.HideTheMessage();
      FB.api(
        "/me?fields=email,name,id,first_name,middle_name,last_name,picture,gender,birthday,link",
        dude => {
          // console.log("dude", dude);
          // console.log(`Good to see you, ${dude.name}.`);
          this.isfacebook = 4;
          this.flag.isBtnFacebook = 2;
          this.issubmit = true;
          this.fb_user_name = dude.name;
          this.fb_profile_url = dude.picture.data.url;

          this.FacebookObject = {};

          this.FacebookObject["isSuccess"] = true;
          this.FacebookObject["facebook_is_submitted"] = 1;
          this.FacebookObject["isManualLink"] = false;
          this.FacebookObject["facebook_id"] = dude["id"] || "";
          this.FacebookObject["facebook_first_name"] = dude["first_name"] || "";
          this.FacebookObject["facebook_last_name"] = dude["last_name"] || "";
          this.FacebookObject["facebook_middle_name"] =
            dude["middle_name"] || "";
          this.FacebookObject["facebook_email"] = dude.email;
          this.FacebookObject["facebook_gender"] = dude["gender"] || "";
          this.FacebookObject["facebook_profile_pic"] = dude.picture.data.url
            ? dude.picture.data.url
            : "";
          this.FacebookObject["facebook_link"] = dude.link;
          this.FacebookObject["facebook_social_link"] = dude.link;
          this.fbuserurl = dude.link;
          this.FacebookObject["facebook_social_manual_link"] = dude.link;
          this.FacebookObject["facebook_hometown"] = dude["address"];
          this.FacebookObject["facebook_is_success"] = true;
          this.saveData(false);
        }
      );
    },

    onSignInError(error) {
      this.HideTheMessage();
      // console.log("OH NOES", error);
    },
    authenticate: function(provider) {
      // console.log("Provider", provider);
      let that = this;
      this.isprovider = provider;
      if (provider == "facebook") {
        this.isfacebook = 1;
      } else if (provider == "instagram") {
        this.isinstagram = 1;
      } else if (provider == "twitter") {
        this.istwitter = 1;
      } else if (provider == "linkedin") {
        this.islinkedin = 1;
      }
      this.$auth
        .authenticate(provider)
        .then(function() {
          // Execute application logic after successful social authentication
          // console.log("Callback Provider", provider);
          // console.log(that, this);
          if (provider == "facebook") {
            that.isfacebook = 2;
          } else if (provider == "instagram") {
            that.isinstagram = 2;
          } else if (provider == "twitter") {
            that.istwitter = 2;
          } else if (provider == "linkedin") {
            that.islinkedin = 2;
          }

          if (provider === "facebook") {
            that.$http
              .get("https://graph.facebook.com/v5.0/me", {
                params: {
                  access_token: that.$auth.getToken(),
                  fields: "id,name,picture"
                }
              })
              .then(function(response) {
                that.response = response;
                // console.log(response);
                that.user_name = response.name;
                that.profile_url = response.picture.data.url;
              });
          } else if (provider === "twitter") {
            that.response = authResponse.body.profile;
          } else if (provider === "instagram") {
            that.response = authResponse;
          } else if (provider === "linkedin") {
            that.response = authResponse;
          }
        })
        .catch(err => {
          // console.log({ err: err });
          if (that.isprovider == "facebook") {
            that.isfacebook = 3;
          } else if (that.isprovider == "instagram") {
            that.isinstagram = 3;
          } else if (that.isprovider == "twitter") {
            that.istwitter = 3;
          } else if (that.isprovider == "linkedin") {
            that.islinkedin = 3;
          }
        });
    }
  }
};
</script>
<style>
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: -ms-flexbox !important;
  display: -webkit-box !important;
  display: flex !important;
  -ms-flex-align: center !important;
  -webkit-box-align: center !important;
  align-items: center !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/index.vue